import React from 'react';
import { func } from 'prop-types';

import { useUrlParam } from '../utils';

import ActionButtons from './ActionButtons';
import { formatPayloadForMission } from './utils';

export default function ActionTagging({ patchChecks }) {
  const { getUrlParam } = useUrlParam();
  const entityId = getUrlParam('entity');

  const formatPayloadTagging = formatPayloadForMission(null, 'tagging');

  return (
    <div className="ActionTagging">
      <ActionButtons
        sendCheck={value => {
          patchChecks(formatPayloadTagging(entityId, value));
        }}
      />
    </div>
  );
}

ActionTagging.propTypes = {
  patchChecks: func.isRequired,
};
